export const api = {
    url: "https://demo.goolivery.com/api/public/api/",
    origin: "https://demo.goolivery.com/",
    redirect: "https://demo.goolivery.com/",
    fidelidade: "https://demo.goolivery.com/fidelidade/",
    owner: "Goolivery Demo",
    group: "pedenaweb",
    group_image: "demo",
    image: "https://demo.goolivery.com/api/",
    site: "www.goolivery.com.br",
    g_social_login:
        "674969690822-rh233u1u207qum3jrfnuv3euvcpuu80b.apps.googleusercontent.com",
    cors: "https://goolivery-cors-2.herokuapp.com/",
    google_api: "AIzaSyBag4oDhZuiLDLfiXNq65qeWJgYPeZPc-I",
    paypal_api:
        "AXEmr4NTGW-vIOaYmL9E4p4JcjNo6P4IlqtbbJhQr7pMabMT5pl2QhhR5scxhk4TPh_Sf6WNGEdaGa_7",
};
